import axios, { Method, post , put} from "axios";
import { Authorization } from "../Data";

const GET = "get";
const POST = "post";
const PUT = "put";
const DELETE = "delete";
const PATCH = "patch";

//const token = Authorization.headers.Authorization;

// axios.interceptors.request.use(
//   (config) => {
//     config.headers.authorization = `Bearer ${token}`;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

var authAxios = axios.create({
  headers: {
    "Content-type": "Application/json",
    "Access-Control-Allow-Origin": "*",
    //"Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
    Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
  },
});

const refreshNewToken = () => {
  authAxios = axios.create({
    headers: {
      "Content-type": "Application/json",
      "Access-Control-Allow-Origin": "*",
      //"Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
    },
  });
};

const request = (
  url,
  type,
  data,
  params,
  headers = { "Content-Type": "application/json" }
) => {
  let baseUrl = process.env.REACT_APP_API_ENDPOINT;
  const routePath = baseUrl + (baseUrl?.slice(-1) === "/" ? "" : "/") + url;

  // headers["Authorization"] = headers["Authorization"]
  //   ? headers["Authorization"]
  //   : token;

  const options = {
    method: type,
    url: routePath,
    data,
    params,
    headers,
  };

  return authAxios(options)
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      return {error:error};
      // if (error.message === "Network Error") {
      //   throw new Error("Please check your internet connection");
      // }
      if (error.response) {
        const statusCode = error.response.status;
        // if (statusCode === 401) {
        //   throw new Error("Unauthorized.");
        // }
        // if (statusCode === 403) {
        //   throw new Error("Permission Denide.");
        // }
        // const message = error.response.data.message;
        // throw new Error(message);
      }
    });
};

const postFileData = (
  url,
  formData
) => {
  let baseUrl = process.env.REACT_APP_API_ENDPOINT;
  const routePath = baseUrl + (baseUrl?.slice(-1) === "/" ? "" : "/") + url;
  const config = {
    headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`,
    }
  };
  return post(routePath, formData, config) .then((result) => {
    return result.data;
  })
  .catch((error) => {
    return {error:error};
    // if (error.message === "Network Error") {
    //   throw new Error("Please check your internet connection");
    // }
    if (error.response) {
      const statusCode = error.response.status;
      // if (statusCode === 401) {
      //   throw new Error("Unauthorized.");
      // }
      // if (statusCode === 403) {
      //   throw new Error("Permission Denide.");
      // }
      // const message = error.response.data.message;
      // throw new Error(message);
    }
  });
};

const putFileData = (
  url,
  formData
) => {
  let baseUrl = process.env.REACT_APP_API_ENDPOINT;
  const routePath = baseUrl + (baseUrl?.slice(-1) === "/" ? "" : "/") + url;
  const config = {
    headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`,
    }
  };
  return put(routePath, formData, config) .then((result) => {
    return result.data;
  })
  .catch((error) => {
    return {error:error};
    // if (error.message === "Network Error") {
    //   throw new Error("Please check your internet connection");
    // }
    if (error.response) {
      const statusCode = error.response.status;
      // if (statusCode === 401) {
      //   throw new Error("Unauthorized.");
      // }
      // if (statusCode === 403) {
      //   throw new Error("Permission Denide.");
      // }
      // const message = error.response.data.message;
      // throw new Error(message);
    }
  });
};

// const getFormData = object => {
//   const formData = new FormData();

//   Object.keys(object).forEach(key => formData.append(key, object[key]));
//   return formData;
// };

export { request, postFileData, putFileData, GET, POST, PUT, DELETE, PATCH, refreshNewToken };
